import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';
import './acknowledge-checkbox.styles.css';

interface AcknowledgeCheckboxProps {
	id: string;
	checked: boolean;
	onChange: () => void;
	label: string;
}

const AcknowledgeCheckbox: React.FC<AcknowledgeCheckboxProps> = ({
	id,
	checked,
	onChange,
	label,
}) => {
	return (
		<div className="checkbox-group">
			<Checkbox
				inputId={id}
				checked={checked}
				onChange={onChange}
				pt={{
					root: { className: 'checkbox-root' },
					box: {
						className: classNames(
							'checkbox-box',
							checked && 'checkbox-box-checked',
						),
					},
					icon: { className: 'checkbox-icon' },
				}}
			/>
			<label htmlFor={id}>{label}</label>
		</div>
	);
};

export default AcknowledgeCheckbox;
